define(function (require, exports, module) {
    'use strict';

    var UploadFail = require('./UploadFail');

    /**
     * @constructor
     * @extends {UploadFail}
     * @param {Error} stack
     * @param {string} source
     */
    function FileExistsFail(stack, source) {
        UploadFail.apply(this, arguments);
    }

    FileExistsFail.WEB_BACKEND_ERROR = 'file_exists';

    FileExistsFail.prototype = Object.assign(Object.create(UploadFail.prototype), {
        constructor: FileExistsFail,
        className: 'FileExistsFail',
        radarName: 'fail_{SOURCE}_file-exists',
        message: ['Файл с таким именем уже существует.', 'Файл с таким именем уже существует.'].join(' '),
    });

    module.exports = FileExistsFail;
});
